//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdmComparisonQuery from '~/apollo/queries/product/pdm-comparison'

export default {
  apollo: {
    pdmComparison: {
      prefetch: true,
      query: pdmComparisonQuery
    }
  }
}
